module.exports = __webpack_public_path__ + "3cd7423df7d808f922898f5be0edcdd8.ttf";